module.exports = __webpack_public_path__ + "static/media/banana1.626568ba.jpg";